import React from 'react';
import { Helmet } from 'react-helmet';


function Contact_Us_Seo() {
    return (
        <div>
            <Helmet>
                <title>Contact Us | Pay Quik</title>
                <meta name="keywords" content="" />
                <meta name="description" content="" />
                <meta property="og:title" content="Contact Us | Pay Quik" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://pay-quik.co.uk/assets/images/logo/site-logo.png" />
                <meta property="og:url" content="https://pay-quik.co.uk/contact" />
                <meta name="twitter:title" content="Contact Us | Pay Quik" />
                <meta name="twitter:description" content="" />
                <meta name="twitter:image" content="https://pay-quik.co.uk/assets/images/logo/site-logo.png" />
            </Helmet>
        </div>
    )
}

export default Contact_Us_Seo
